export default "__VITE_ASSET__CX68AtUF__"